export { ModalHeadline } from './ModalHeadline';
